import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokenService } from '@services/auth/token.service';
import { environment } from 'environments/environment';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  public viewUsers: BehaviorSubject<any>;

  constructor(public http: HttpClient, private _token: TokenService) {}

  addNewUser(user_data: Object) {
    const URL = `${environment.api}users/user-add`;

    return this.http
      .post(URL, user_data, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  userList(user_list: Object, pageNo: number = 1) {
    const URL = `${environment.api}users/user-list`;

    return this.http
      .post(URL, user_list, {
        headers: this._token.getTokenHeader(),
        params: {
          page: pageNo,
        },
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  searchUserList(searchValue: object, pageNo: number = 1) {
    const URL = `${environment.api}users/user-list`;

    return this.http
      .post(URL, searchValue, {
        headers: this._token.getTokenHeader(),
        params: { page: pageNo },
      })
      .pipe(
        map((result: any) => {
          if (result && result['data']) {
            return result;
          }
        })
      );
  }

  viewUser(user_id: string) {
    const url = `${environment.api}users/user-view/${user_id}`;

    return this.http.get(url, { headers: this._token.getTokenHeader() });
  }

  deleteUser(user_id: any) {
    const URL = `${environment.api}users/user-delete/${user_id}`;

    return this.http
      .delete(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getUserRole() {
    const URL = `${environment.api}settings/user-role-list`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  // END

  editUser(data: any, user_id: any) {
    const URL = `${environment.api}users/user-edit/${user_id}`;

    return this.http.put(URL, data, { headers: this._token.getTokenHeader() });
  }

  deleteProductDoc(doc_info: Object) {
    const URL = `${environment.api}image/delete `;

    return this.http
      .post(URL, doc_info, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getWinnerList() {
    const URL = `${environment.api}auction/bidding/history/7bb9d700-0810-431f-93e9-6f0e5f51b8d1`;

    return this.http.get(URL, {
      headers: this._token.getTokenHeader(),
      params: {
        winner: true,
        entity_type: 'group',
      },
    });
  }

  updateUserDocStatus(userId: string, docInfo: object) {
    const URL = `${environment.api}users/user-edit/${userId}`;

    return this.http
      .put(URL, docInfo, { headers: this._token.getTokenHeader() })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  userPDI(payload: object) {
    const URL = `${environment.recycleApi}user/pdi/vehicle`;

    return this.http.post(URL, payload);
  }

  addPdiUserDetails(payload: object) {
    const URL = `${environment.pdiAPI}pdi/user/add`;

    return this.http.post(URL, payload);
  }

  updatePdiUserInfo(pdiUserId: string, payload: object) {
    const URL = `${environment.pdiAPI}pdi/user/edit/${pdiUserId}`;

    return this.http.put(URL, payload, {
      headers: this._token.getTokenHeader(),
    });
  }

  getPdiUsers() {
    const URL = `${environment.pdiAPI}pdi/user/view`;

    return this.http.get(URL);
  }

  getCities(payload: object) {
    const URL = `${environment.api}user/city/list`;

    return this.http.post(URL, payload);
  }
}
